
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Icon extends Vue {
  @Prop({ required: true }) name!: string;

  icon: string | null = null;

  async created(): Promise<void> {
    const module = await import(`@/assets/${this.name}.svg`);
    this.icon = module.default;
  }
}
